import React from "react";
import InputRequire from "views/components/InputRequire";

export const CoefficientInput = ({ value, onChange, errors = [], t }) => {
  return (
    <div className="col col-12 col-md-6">
      <div className={errors.length ? "form-group validated" : "form-group"}>
        <label
          htmlFor="coef"
          title={t("Coefficient de la relance")}
          data-toggle="tooltip"
          data-placement="bottom"
        >
          {t("Coefficient")} <InputRequire />
          <i className="fa fa-info-circle" />
        </label>
        <div className="mb-3">
          <input
            id="coef"
            type="text"
            className={
              errors.length ? "form-control is-invalid" : "form-control"
            }
            placeholder={t("Veuillez entrer le Coefficient")}
            value={value}
            onChange={onChange}
            style={{ height: 45 }}
          />
          {errors.length > 0 &&
            errors.map((error, index) => (
              <div key={index} className="invalid-feedback">
                {error}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
